



















import { Component, Prop, Watch, Vue } from "vue-property-decorator";

import CustomChart, { CustomChartItem } from "@/components/CustomChart.vue";
import { HeatmapTableRow } from "@/components/HeatmapTable.vue";

export type ChartWeekRange = {
  label: string;
  columnName: string;
};

@Component({ components: { CustomChart } })
export default class SpecialInitiativesChart extends Vue {
  @Prop({ default: "bar" }) readonly type!: string;
  @Prop({ default: false }) readonly stacked!: boolean;
  @Prop({ default: false }) readonly percentage!: boolean;

  @Prop({ default: () => [] }) readonly weekRanges!: ChartWeekRange[];
  @Prop({ default: () => [] }) readonly items!: HeatmapTableRow[];
  @Prop({ required: true }) readonly loading!: boolean;

  chartLabels: string[] = [];
  chartItems: CustomChartItem[] = [];

  @Watch("items")
  onItemsChanged(items: HeatmapTableRow[]) {
    this.chartItems = this.loadChartItems(this.weekRanges, items);
  }

  @Watch("weekRanges")
  onWeekRangesChanged(weekRanges: ChartWeekRange[]) {
    this.chartLabels = this.loadChartLabels(weekRanges);
  }

  loadChartLabels(weekRanges: ChartWeekRange[]): string[] {
    return weekRanges.map((wr) => wr.label);
  }

  loadChartItems(
    weekRanges: ChartWeekRange[],
    items: HeatmapTableRow[]
  ): CustomChartItem[] {
    const results = items.map((element) => {
      const item: CustomChartItem = {
        label: element.subject,
        data: weekRanges.map((column) => {
          if (element[column.columnName]) {
            return element[column.columnName].type == "quoted"
              ? element[column.columnName].value
              : element[column.columnName];
          } else {
            return 0;
          }
        }),
      };
      return item;
    });
    return results;
  }

  onItemHidden(index: number) {
    if (this.items[index] !== undefined) {
      this.$emit("item-hidden", this.items[index]);
    }
  }

  onItemVisible(index: number) {
    if (this.items[index] !== undefined) {
      this.$emit("item-visible", this.items[index]);
    }
  }
}
